import Service from './index'
import store from '../store/index.js'
import { handleError } from '../utils/errorHandler.js'

Service.interceptors.response.use(
  res => res,
  err => {
    if (typeof err.response !== 'undefined') {
      // For validation errors (400), don't show alert here - let component handle it
      if (err.response.status === 400 && err.response.data && err.response.data.errors) {
        // Just throw the error, component will handle display
        throw err
      } else {
        // For other errors, show alert from global interceptor
        const message = handleError(err, true)
        throw new Error(message)
      }
    } else {
      // Network or other errors
      const message = 'Network error. Please check your connection.'
      alert(message)
      throw new Error(message)
    }
  }
)

export default {
  getList (apiRoute) {
    return Service.get(`${apiRoute}`)
  },

  get (apiRoute) {
    this.setHeader()
    return Service.get(`${apiRoute}`)
  },

  getData (apiRoute, Id) {
    this.setHeader()
    return Service.get(`${apiRoute}/${Id}`)
  },

  getIds (apiRoute, Ids) {
    this.setHeader()
    return Service.post(`${apiRoute}/getIds`, JSON.stringify(Ids))
  },

  getList (apiRoute, data) {
    this.setHeader()
    return Service.post(`${apiRoute}/list`, data)
  },

  getCode (apiRoute, data) {
    this.setHeader()
    return Service.post(`${apiRoute}/getCode`, data)
  },

  searchList (apiRoute, data) {
    this.setHeader()
    const url = `${apiRoute}/search`
    return Service.post(url, data)
  },

  listAll (apiRoute, data) {
    this.setHeader()
    return Service.post(`${apiRoute}/list`, data)
  },

  postAction (apiRoute, action, data) {
    this.setHeader()
    return Service.post(`${apiRoute}/${action}`, data)
  },
  
  updateData (apiRoute, data, id, axiosConfig = {}) {
    this.setHeader()
    if (id && id !== 0) {
      return Service.put(`/${apiRoute}/${id}`, data, axiosConfig)
    }
    return Service.post(`${apiRoute}`, data, axiosConfig)
  },

  deleteData (apiRoute, data) {
    this.setHeader()
    if (data.id && data.id !== 0) {
      return Service.delete(`/${apiRoute}/${data.id}`, {
        data: data,
        headers: {
          'Content-Type': 'application/json'
        }
      })
    }
  },

  getAccount (Id) {
    this.setHeader()
    return Service.get(`account/${Id}`)
  },

  getDMSData (apiRoute) {
    this.setHeader()
    return this.get(`jaqservice/${apiRoute}`)
  },

  postDMSData (apiRoute, data) {
    this.setHeader()
    return Service.post(`jaqservice/${apiRoute}`, data)
  },

  setHeader () {
    Service.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.authToken
  }
}

// // import Service from './index'
// import Service from 'axios'
// import store from '../store/index.js'
// // import store from '../store/index.js'

// // You can use your own logic to set your local or production domain
// var baseDomain = ''
// if (process.env.NODE_ENV === 'development') {
//   baseDomain = 'http://localhost:5000/api/'
// } else if (process.env.NODE_ENV === 'production') {
//   baseDomain = 'http://149.129.129.112:51000/api/'
// }
// // The base URL is empty this time due we are using the jsonplaceholder API
// const baseURL = `${baseDomain}`
// Service.defaults.baseURL = baseURL

// Service.interceptors.response.use(
//   res => res,
//   err => {
//     if (typeof err.response !== 'undefined') {
//       var message = ''
//       if (err.response.status === 401) {
//         message = 'You are not authorised for this action.'
//       } else if (err.response.status === 400) {
//         message = 'Invalid Data, try to specify.'
//       } else if (err.response.status === 404) {
//         message = 'Unable to connect.'
//       } else if (err.response.status === 405) {
//         message = 'Access denied.'
//       } else if (err.response.status === 422) {
//         message = 'System error.' // user defined custom error
//       } else if (err.response.status >= 500) {
//         message = 'Technical error.'
//       }
//       alert(message)
//     }
//     throw new Error(err.response.data.message)
//   }
// )

// export default {
//   getList (apiRoute) {
//     return Service.get(`${apiRoute}`)
//   },

//   get (apiRoute) {
//     // console.log(localStorage.getItem('token'))
//     console.log(store.getters.authToken)
//     Service.defaults.headers.common['Authorization'] = this.getToken()
//     console.log(Service.defaults.headers.common['Authorization'])
//     return Service.get(`${apiRoute}`)
//   },

//   getData (apiRoute, Id) {
//     Service.defaults.headers.common['Authorization'] = this.getToken()
//     return Service.get(`${apiRoute}/${Id}`)
//   },

//   searchList (apiRoute, data) {
//     Service.defaults.headers.common['Authorization'] = this.getToken()
//     return Service.post(`${apiRoute}/search`, data)
//   },

//   updateData (apiRoute, data, id) {
//     Service.defaults.headers.common['Authorization'] = this.getToken()
//     if (id && id !== 0) {
//       return Service.put(`/${apiRoute}/${id}`, data)
//     } else return Service.post(`${apiRoute}`, data)
//   },

//   deleteData (apiRoute, data) {
//     if (data.id && data.id !== 0) {
//       var header = { 'Content-Type': 'application/json', 'Authorization': this.getToken(), 'Accept': 'application/json' }
//       return Service.delete(`/${apiRoute}/${data.id}`, { header, data })
//     }
//   },

//   getToken () {
//     return 'Bearer ' + store.getters.authToken
//   }
// }
